import React from "react";
import CrudPage from "./CrudPage";
export default function AdminAssessors() {
  return <CrudPage title="Asesor" endpoint="assessors" testPrefix="assessor" fields={[
    {key: "name", label: "Nama"},
    {key: "position", label: "Jabatan"},
    {key: "expertise", label: "Bidang Keahlian"},
    {key: "certifications", label: "Sertifikasi"},
    {key: "bio", label: "Deskripsi", type: "textarea"},
    {key: "photo_url", label: "URL Foto"},
  ]} />;
}
